// @ts-nocheck
const body = document.body;
const sticky_menu_class = ".sticky-menu-section";

const getCSSVar = (name) => parseFloat(getComputedStyle(body).getPropertyValue(name)) || 0;

function updateScrollSpy(menu_id, scrollTop) {
  menu_id = menu_id || 'div[id*="sticky-menu"]';

  const body = document.body;
  const header = document.getElementById("header-component");
  const currentTop = window.scrollY;

  const menu = document.querySelector(menu_id);
  if (!menu) return;

  const elems = menu.querySelectorAll(".menu-link");
  if (!elems.length) return;

  let navElem = null;

  elems.forEach((el, index) => {
    const link = (el.getAttribute("href") || "").trim();

    // Skip external links
    if (link.includes("/") || link.includes("http")) return;

    const name = link.replace("#", "");
    const target = document.querySelector(`#${name}`);
    if (!target) return;

    const hasAnnouncement =
      document.querySelectorAll(
        ".shopify-section-header-announcement .swiper-slide",
      ).length > 0;

    const headerHeight = header ? header.offsetHeight : 0;

    let elemTop =
      target.getBoundingClientRect().top +
      window.scrollY - 20 -
      (body.classList.contains("scroll-top") ? headerHeight * 2 : 0) -
      (body.classList.contains("scroll-btm") ? headerHeight * 1.5 : 0) -
      (window.innerWidth > 480
        ? hasAnnouncement
          ? 80
          : 120
        : hasAnnouncement
          ? 80
          : 40);

    const nextEl = elems[index + 1];

    let elemBottom =
      elemTop +
      (nextEl
        ? nextEl.getBoundingClientRect().top + window.scrollY
        : document.getElementById("MainContent")?.offsetHeight || 0);

    if (
      (currentTop >= elemTop && currentTop <= elemBottom) ||
      (elemTop === elemBottom && currentTop >= elemBottom)
    ) {
      navElem = menu.querySelector(`.menu-link[href="#${name}"]`);
    }
  });

  // Apply active class
  if (navElem && !navElem.classList.contains("active")) {
    elems.forEach((el) => el.classList.remove("active"));
    navElem.classList.add("active");
  } else if (!navElem) {
    elems.forEach((el) => el.classList.remove("active"));
  }
}

function scrollAnchor(anchor) {
  const el = document.querySelector(`[name="${anchor}"]`) || document.getElementById(anchor);
  if (!el) return;

  // Get absolute position once
  let pos = el.getBoundingClientRect().top + window.scrollY;

  let h = getCSSVar("--header-height");

  const isMobile = window.innerWidth < 1024;
  const scrollTop = window.scrollY;

  if (isMobile && body.classList.contains("scroll-btm")) {
    h = getCSSVar("--header-v3-height");
  }

  if (isMobile && scrollTop > pos) {
    h += getCSSVar("--header-announcement-height");
  }

  h += getCSSVar("--sticky-menu-height");

  // Final position calc
  pos = pos - 20 - h - (window.innerWidth > 480 ? 40 : 0);

  // Native smooth scroll (better performance than jQuery animate)
  window.scrollTo({
    top: Math.max(0, pos),
    behavior: "smooth",
  });
}

function handleStickyNavPosition() {
  if (document.querySelector('body')) {
    const header = document.getElementById("header-component");
    const headerHeight = header ? header.offsetHeight : 72;
    document.querySelector('body')?.style.setProperty("--header-height-top", `${headerHeight - 2}px`);
  }
}

window.addEventListener("resize", () => {
  handleStickyNavPosition();
});

// Load
window.addEventListener("load", () => {
  if (location.hash) {
    scrollAnchor(location.hash.slice(1));
  }

  handleStickyNavPosition();

  document.querySelector(".menu-button")?.addEventListener("click", function (e) {
    const menu = e.target.closest(sticky_menu_class);
    if (!menu) return;

    menu.classList.toggle("active");
    document.getElementById("MainContent")?.classList.toggle("page-sticky-menu-section-active");
  });

  document.querySelector(sticky_menu_class).addEventListener('click', function (e) {
    const target = e.target.closest('.menu-link, .cta-button');
    if (!target) return;

    // remove classes
    document.querySelector(sticky_menu_class)?.classList.remove('active');
    document.getElementById('MainContent')?.classList.remove('page-sticky-menu-section-active');

    const link = (target.getAttribute('href') || '').trim();

    // allow normal navigation for external/internal full URLs
    if (link.includes('/')) {
      return true;
    }

    const anchor = link.replace('#', '');

    e.preventDefault();

    // call your existing function
    scrollAnchor(anchor);

    history.replaceState(null, '', window.location.pathname + window.location.search);
  });
});

window.addEventListener("scroll", function () {
  updateScrollSpy(sticky_menu_class, window);
});
